import MuiGrid, { GridProps } from "@mui/material/Grid";

const Grid: React.FC<GridProps> = MuiGrid;

export default Grid;

export type { GridProps };
